<dr-flex-home-ui-widget-header
  [title]="'FLEX_HOME.DISPATCH_WIDGET.TITLE' | translate"
  [link]="{ text: ('FLEX_HOME.DISPATCH_WIDGET.GO_TO_ACTIVE_DISPATCHES' | translate), href: activeEventsUrl }"
  [mixpanelClickEvent]="mixPanelEvent.CLICK_GO_ACTIVE_DISPATCHES"
></dr-flex-home-ui-widget-header>
@if (dispatches() === null) {
  <div class="loading-spinner">
    <dsy-loader type="spinner" size="xx-small" animation-speed="slow"></dsy-loader>
  </div>
} @else if (dispatches()?.length) {
  <div class="dispatch-list">
    @for (item of dispatches(); track item.id) {
      <dsy-card class="dispatch-list__card" card-color="#fff" height="auto" custom-style="border-radius: 1.25rem" is-round-border="true" has-border="true" no-padding="true">
        <div class="dispatch-card">
          <div class="dispatch-card__details">
            <div class="dispatch-card__line dispatch-card__title">
              <span>
                {{ item.org ? item.org + (item.site ? ' | ' : '') : '' }}
                <span class="dispatch-card__site">{{ item.site || '' }}</span>
              </span>
            </div>
            <div class="dispatch-card__line">{{ 'FLEX_HOME.DISPATCH_WIDGET.PROGRAM' | translate }}: {{ item.program }}</div>
            <div class="dispatch-card__line dispatch-card__line--start">
              {{ 'FLEX_HOME.DISPATCH_WIDGET.START' | translate }}: {{ item.startUtc | timezoneDate: item.timeZone : locale() }}
            </div>
          </div>
          <a class="dispatch-card__status dispatch-card__status--{{ item.status }}" [href]="activeEventsUrl">
            @if (item.status === 'upcoming') {
              <dsy-icon class="dispatch-card__icon dispatch-card__icon--upcoming" library="system" name="info-icon" size="0.94rem"></dsy-icon>
              <span>{{ 'FLEX_HOME.DISPATCH_WIDGET.STATUS.UPCOMING' | translate }}</span>
            }
            @if (item.status === 'ongoing') {
              <dsy-icon class="dispatch-card__icon dispatch-card__icon--ongoing" library="system" name="info-icon" size="0.94rem"></dsy-icon>
              <span>{{ 'FLEX_HOME.DISPATCH_WIDGET.STATUS.ONGOING' | translate }}</span>
            }
            <dsy-icon class="dispatch-card__icon dispatch-card__icon--arrow" library="material" name="chevron_right" size="1rem"></dsy-icon>
          </a>
        </div>
      </dsy-card>
    }
  </div>
} @else {
  <div class="empty">
    <dr-flex-home-ui-empty-state [showPermissionStatus]="true" [title]="'FLEX_HOME.DISPATCH_WIDGET.NO_DATA'"></dr-flex-home-ui-empty-state>
  </div>
}
